import { render, staticRenderFns } from "./Saee10RecommendedInformation.vue?vue&type=template&id=37e23c5a&scoped=true"
import script from "./Saee10RecommendedInformation.vue?vue&type=script&lang=js"
export * from "./Saee10RecommendedInformation.vue?vue&type=script&lang=js"
import style0 from "./Saee10RecommendedInformation.vue?vue&type=style&index=0&id=37e23c5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e23c5a",
  null
  
)

export default component.exports